import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { withStyles } from '@material-ui/core/styles';
import TemporaryDrawerList from './TemporaryDrawerList';

const styles = {
  list: {
    width: 250,
  },
};

const TemporaryDrawer = (props) => {

    const { isDrawerOpen, toggleDrawer, classes, routes } = props;

    return (
      <SwipeableDrawer open={isDrawerOpen} onOpen={toggleDrawer(true)} onClose={toggleDrawer(false)}>
            <div className={classes.list}>
              <TemporaryDrawerList routes={routes}/>
            </div>
      </SwipeableDrawer>
    )
  }


export default withStyles(styles)(TemporaryDrawer);


// WEBPACK FOOTER //
// ./src/components/Header/TemporaryDrawer.js